export const PRIVACY_PROMISE_DETAILS = [
    {
        title: "What's encrypted",
        body: "Journals, Hope conversations, and your check-in progress are encrypted in transit (TLS) and at rest on our servers.",
    },
    {
        title: "Where your data lives",
        body: "Stored on secure, US-based cloud infrastructure with access controls, monitoring, and regular security maintenance.",
    },
    {
        title: "Who can read your journals",
        body: "No one on our team reads your journals — not for ads, not for model training, not for routine review. Your entries are fully encrypted in transit and at rest and stay private to your account. We do not share them with insurers or employers.",
    },
    {
        title: "Insurers & employers",
        body: "We do not share your recovery data with insurance companies, employers, or marketers. Your story is not a product.",
    },
    {
        title: "Legal requests",
        body: "If we receive a valid subpoena or court order, we respond as required by law. When we are legally permitted to do so, we will notify you.",
    },
    {
        title: "Delete & export",
        body: "Export or delete your account data anytime from the app — one tap, no runaround.",
    },
];
